// FETCH ALL PROPERTIES FROM STYLE_DETAIL PAGE
export const FETCH_STYLE_DETAIL_REQUEST = 'FETCH_STYLE_DETAIL_REQUEST';
export const FETCH_STYLE_DETAIL_SUCCESS = 'FETCH_STYLE_DETAIL_SUCCESS';
export const FETCH_STYLE_DETAIL_FAILURE = 'FETCH_STYLE_DETAIL_FAILURE';
// FETCH ALL PROPERTIES by ID FROM STYLE_DETAIL PAGE
export const FETCH_STYLE_DETAIL_BY_ID_REQUEST = 'FETCH_STYLE_DETAIL_BY_ID_REQUEST';
export const FETCH_STYLE_DETAIL_BY_ID_SUCCESS = 'FETCH_STYLE_DETAIL_BY_ID_SUCCESS';
export const FETCH_STYLE_DETAIL_BY_ID_FAILURE = 'FETCH_STYLE_DETAIL_BY_ID_FAILURE';

// CREATE PROPERTIES FOR STYLE_DETAIL PAGE
export const CREATE_STYLE_DETAIL_REQUEST = 'CREATE_STYLE_DETAIL_REQUEST';
export const CREATE_STYLE_DETAIL_SUCCESS = 'CREATE_STYLE_DETAIL_SUCCESS';
export const CREATE_STYLE_DETAIL_FAILURE = 'CREATE_STYLE_DETAIL_FAILURE';

// UPDATE PROPERTIES FOR STYLE_DETAIL PAGE
export const UPDATE_STYLE_DETAIL_REQUEST = 'UPDATE_STYLE_DETAIL_REQUEST';
export const UPDATE_STYLE_DETAIL_SUCCESS = 'UPDATE_STYLE_DETAIL_SUCCESS';
export const UPDATE_STYLE_DETAIL_FAILURE = 'UPDATE_STYLE_DETAIL_FAILURE';

// FETCH SINGLE PROPERTY FOR STYLE_DETAIL PAGE
export const FETCH_SINGLE_STYLE_DETAIL_REQUEST = 'FETCH_SINGLE_STYLE_DETAIL_REQUEST';
export const FETCH_SINGLE_STYLE_DETAIL_SUCCESS = 'FETCH_SINGLE_STYLE_DETAIL_SUCCESS';
export const FETCH_SINGLE_STYLE_DETAIL_FAILURE = 'FETCH_SINGLE_STYLE_DETAIL_FAILURE';

// DELETE PROPERTIES FOR STYLE_DETAIL PAGE
export const DELETE_STYLE_DETAIL_REQUEST = 'DELETE_STYLE_DETAIL_REQUEST';
export const DELETE_STYLE_DETAIL_SUCCESS = 'DELETE_STYLE_DETAIL_SUCCESS';
export const DELETE_STYLE_DETAIL_FAILURE = 'DELETE_STYLE_DETAIL_FAILURE';

export const CREATE_USER_FORM_STYLE_DETAIL = 'CREATE_USER_FORM_STYLE_DETAIL';
export const STYLE_DETAIL_USERFORM_RESET = 'STYLE_DETAIL_USERFORM_RESET';
export const STYLE_DETAIL_USERFORM_DROPDOWNLIST_RESET = 'STYLE_DETAIL_USERFORM_DROPDOWNLIST_RESET';

// UPDATE STYLE_DETAIL FROM STYLE PREPARATIONS
export const UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST = 'UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST';
export const UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS = 'UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS';
export const UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE = 'UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE';

// navigate to access info page
export const NAVIGATE_STYLE_MASTER = 'NAVIGATE_STYLE_MASTER';
// navigate to access details page
export const NAVIGATE_STYLE_DETAILS = 'NAVIGATE_STYLE_DETAILS';


export const UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_REQUEST = 'UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_REQUEST';
export const UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_SUCCESS = 'UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_SUCCESS';
export const UPDATE_STYLE_DETAIL_FROM_FABRIC_INFO_FAILURE = 'UPDATE_STYLE_DETAIL_FROM_FABRIC_INFO_FAILURE';


export const FETCH_STYLE_DETAIL_UPLOAD_IMAGES_REQUEST = 'FETCH_STYLE_DETAIL_UPLOAD_IMAGES_REQUEST';
export const FETCH_STYLE_DETAIL_UPLOAD_IMAGES_SUCCESS = 'FETCH_STYLE_DETAIL_UPLOAD_IMAGES_SUCCESS';
export const FETCH_STYLE_DETAIL_UPLOAD_IMAGES_FAILURE = 'FETCH_STYLE_DETAIL_UPLOAD_IMAGES_FAILURE';



export const FETCH_STYLE_DETAIL_NEW_COLOR_ADD_REQUEST = 'FETCH_STYLE_DETAIL_NEW_COLOR_ADD_REQUEST';
export const FETCH_STYLE_DETAIL_NEW_COLOR_ADD_SUCCESS = 'FETCH_STYLE_DETAIL_NEW_COLOR_ADD_SUCCESS';
export const FETCH_STYLE_DETAIL_NEW_COLOR_ADD_FAILURE = 'FETCH_STYLE_DETAIL_NEW_COLOR_ADD_FAILURE';

export const RESET_UPLOAD_IMAGES_DATA = 'RESET_UPLOAD_IMAGES_DATA'
